import {
  INIT,
  INIT_SUCCESS,
  INIT_FAILED,
  SAVE,
  SAVE_SUCCESS,
  SAVE_FAILED,
  RESOLVE_LOCATION_DETAILS,
  REMOVE,
  REMOVE_SUCCESS,
  REMOVE_FAILED,
} from './constants';

export interface InitAction {
  type: typeof INIT;
  id: string;
}
export const initAction = (id) => ({
  type: INIT,
  id,
});
export const initSuccessAction = () => ({
  type: INIT_SUCCESS,
});
export const initFailedAction = (error?, errorCode?) => ({
  type: INIT_FAILED,
  error,
  errorCode,
});

export const saveAction = (data) => ({
  type: SAVE,
  data,
});
export const saveSuccessAction = (location) => ({
  type: SAVE_SUCCESS,
  location,
});
export const saveFailedAction = (error, errorCode?, additional = {}) => ({
  type: SAVE_FAILED,
  error,
  errorCode,
  ...additional,
});

export const removeAction = (locationId) => ({
  type: REMOVE,
  locationId,
});

export const removeSuccessAction = () => ({
  type: REMOVE_SUCCESS,
});

export const removeFailedAction = (error, errorCode, additional?) => ({
  type: REMOVE_FAILED,
  error,
  errorCode,
  ...additional,
});

export const resolveLocationDetails = (place) => ({
  type: RESOLVE_LOCATION_DETAILS,
  place,
});
